<template>
  <div class="bg">
    <b-container fluid>
      <b-row>
        <b-col md="4"/>
        <b-col md="4">
            <b-form id="frmLogin" @submit.prevent="formLogin()">
              <h5>{{frmLogin.titulo}}</h5>
              <b-form-group
                id="txtUserName-group"
                label="DNI"
                label-for="txtUserName"
              >
                <b-form-input
                  id="txtUserName"
                  type="text"
                  value
                  required
                  v-model="credentials.UserName"
                  placeholder="DNI"
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="txtContraseña-group"
                label="Contraseña"
                label-for="txtContraseña"
              >
                <b-form-input
                  id="txtContraseña"
                  type="password"
                  required
                  value
                  v-model="credentials.Password"
                  placeholder="Contraseña"
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>


              <b-button
                id="btnIniciarSesion"
                type="submit"
                block
                :disabled="disabled"
                variant="primary"
              >
              {{frmLogin.btnTitulo}}
              </b-button>
            </b-form>
            <b-alert variant="danger" :show="failed" dismissible>{{message}}</b-alert>
          <div class="footer">
                <p>{{nombreSede}}</p>
            <p>{{nombreObispado}}</p>
          </div>
        </b-col>
        <b-col md="4"/>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import auth from "@/auth/auth";
import { mapActions } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      failed : false,
      message: '',
      nombreSede : 'Sede Administrativa de las Escuelas Diocesanas',
      nombreObispado :'Obispado de Santiago del Estero',
      frmLogin:{
        titulo : "SAED Licencias | Iniciar Sesión",
        btnTitulo : 'Iniciar Sesión'

      },

      credentials: {
        UserName: "",
        Password: ""
      },
      anio: "2018",
      username: "",
      password: "",
      errorMensaje: "",
      color: "#0069d9",
      width: 300,
      disabled: false
    };
  },
  methods: {
    ...mapActions(["login", "userInfo", "logout"]),

    formLogin() {
      let self = this;
      this.disabled = true;
      this.login(this.credentials)
        .catch(err => {
          this.failed = true;
          if (err.response && err.response.status === 400) {
            this.message = err.response.data.error_description;
          } else {
            this.message = "No se pudo conectar al servidor. Revise su conexión a internet e inténtelo de nuevo más tarde.";
          }
          this.disabled = false;
        })
        .then(res => {
          return this.userInfo();
        })
        .then(res => {
          var roles = res.data ? res.data.Roles : [];
          self.$router.push("/home");
        });
    }
  }
};
</script>

<style>
.msjIniciando {
  color: rgb(92, 92, 92);
}

.bg {
  background-size: cover;
  background-color: rgb(7, 71, 166);
  height: 100%;
}

#btnIniciarSesion{
  margin-top: 20px;
}
#frmLogin{
  background-color:rgb(255, 255, 255);
  margin-top: 150px;
  margin-bottom: 30px;
  border-radius: 5px;
  padding: 30px;
}
h5{
  color:rgb(70, 70, 70);
  margin-bottom: 35px;
  text-align: center;
}
input{
  margin-bottom: 10px;
}
.footer{
  text-align: center;
  color: rgb(255, 255, 255);
}
.footer p{
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue